<template>
    <v-stepper-content :step="step">
        <div>
            <div class="text-center">
            </div>
            <v-row justify="center">
                <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
                    <v-icon x-large center>mdi-check</v-icon><br>
                    Terimakasih telah mendaftar :)<br>

                    Silahkan Join salah satu grup Whatsapp melalui link di bawah untuk mendapatkan pengumuman tentang Freemium I Batch I 2022<br>
                    <a href="https://chat.whatsapp.com/IMeMQ6UwR5oLKjphuoHe1o">Grup 1</a><br>
                    <a href="https://chat.whatsapp.com/EjFPovPqshR5ZI2WsVLuL7">Grup 2</a><br>
                    <a href="https://chat.whatsapp.com/CGBhy7C8OrWEwl3vinSs2F">Grup 3</a><br>
                    <a href="https://chat.whatsapp.com/HxHw4YETl17A5bHjCtZl8Y">Grup 4</a><br>

                    Gabung channel telegram (opsional) untuk dapatkan quiz setiap harinya: <a href="https://t.me/medikoindonesia">@medikoindonesia</a><br>

                    Apabila ada kendala, hubungi admin di:<br />
                    <admin-contact></admin-contact>
                </v-col>

                <v-col cols="12" sm="2" md="4" lg="6" class="text-center">
                    Kerjakan try out di aplikasi atau web Mediko.id pada<br>
                    <b>Minggu, 26 Desember 2021 17:00 WIB</b><br>
                    Dan pastikan kalian sudah memilih<br>
                    <b>Freemium I Batch I 2022</b><br>
                    <v-img src="@/assets/images/info/periodSelect.jpg" height="512" contain></v-img>
                </v-col>
            </v-row>

            <div class="text-center">
                <v-btn @click="reload" text>Muat ulang</v-btn>
            </div>
        </div>
    </v-stepper-content>
</template>

<script>
import AdminContact from './AdminContact'

export default {
    props: {
        step: {
            type: String,
        }
    },

    components: {
        AdminContact,
    },

    methods: {
        reload() {
            window.location.reload()
        }
    }
}
</script>
